'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Autogenerated by Thrift Compiler (0.9.3-airbnb12)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
var PropTypes = process.env.NODE_ENV === 'production' ? null : require('prop-types');
var logging_type_page_name_v1 = process.env.NODE_ENV === 'production' ? {} : require('./logging_type_page_name_v1');

var ScreenOrientation = exports.ScreenOrientation = {
  Portrait: 1,
  Landscape: 2
};

var MobileBuildType = exports.MobileBuildType = {
  Debug: 1,
  Alpha: 2,
  Beta: 3,
  QA: 4,
  Release: 5,
  China: 6
};

/**
 * Module name - refers to the name field defined in project.yml
 */
var HTTPMethodType = exports.HTTPMethodType = {
  GET: 1,
  POST: 2,
  PUT: 3,
  PATCH: 4,
  DELETE: 5
};

/**
 * Flow type used to identify global and china events
 */
var TrafficType = exports.TrafficType = {
  GLOBAL: 1,
  CHINA: 2
};

var WebContext = exports.WebContext = {
  defaultProps: {},
  propTypes: {
    controller: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    page: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    action: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    rendered_on: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    viewport: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    req_uuid: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    page_uri: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    page_referrer: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    canonical_url: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    shardset: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    local_time: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    queued: process.env.NODE_ENV === 'production' ? {} : PropTypes.bool,
    canonical_host: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    app: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    section_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};

/**
 * plugin point name for the section
 */
var MonorailContext = exports.MonorailContext = {
  defaultProps: {},
  propTypes: process.env.NODE_ENV === 'production' ? {} : {
    controller: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    action: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    api_client_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_device_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_client_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_protocol: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_version: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_resource: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_format: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_intents: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};

var MobileContext = exports.MobileContext = {
  defaultProps: {},
  propTypes: process.env.NODE_ENV === 'production' ? {} : {
    device_type: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    device_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    version_code: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    screen_orientation: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(ScreenOrientation)).isRequired,
    network_type: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    carrier_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    carrier_country: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    build_type: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(MobileBuildType)),
    view_class_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    native_mode: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    module_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};

var ServiceContext = exports.ServiceContext = {
  defaultProps: {},
  propTypes: process.env.NODE_ENV === 'production' ? {} : {
    service_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    local_request_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    http_method_type: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(HTTPMethodType)),
    endpoint_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    global_request_chain_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};

/**
 * Contains fields describing device profile (currently only client
 * computed device year class).
 */
var DeviceProfile = exports.DeviceProfile = {
  defaultProps: {},
  propTypes: process.env.NODE_ENV === 'production' ? {} : {
    device_year_class: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};

/**
 * Contains fields describing the context an event was logged from.
 */
var Context = exports.Context = {
  defaultProps: {},
  propTypes: {
    timestamp: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    source: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    platform: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    user_agent: process.env.NODE_ENV === 'production' ? {} : PropTypes.string.isRequired,
    version: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    bev: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    user_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hash_user_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    language: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    locale: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    campaign: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    affiliate_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    screen_width: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    screen_height: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    web: process.env.NODE_ENV === 'production' ? {} : PropTypes.shape(WebContext.propTypes),
    monorail: process.env.NODE_ENV === 'production' ? {} : PropTypes.shape(MonorailContext.propTypes),
    mobile: process.env.NODE_ENV === 'production' ? {} : PropTypes.shape(MobileContext.propTypes),
    extra_data: process.env.NODE_ENV === 'production' ? {} : PropTypes.objectOf(PropTypes.string),
    client_session_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    bev_expiry: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    service_context: process.env.NODE_ENV === 'production' ? {} : PropTypes.shape(ServiceContext.propTypes),
    page_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(logging_type_page_name_v1.PageName)),
    amp_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    req_remote_host: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    amp_client_session_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    previous_page_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(logging_type_page_name_v1.PageName)),
    visitor_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    impression_uuid: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    api_request_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    max_deferred_minutes: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    environment: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    device: process.env.NODE_ENV === 'production' ? {} : PropTypes.shape(DeviceProfile.propTypes),
    traffic_type: process.env.NODE_ENV === 'production' ? {} : PropTypes.oneOf(Object.values(TrafficType)),
    context_api_client_id: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-jitney-schemas/logging_context_v2.js
// module id = 455
// module chunks = 168707334958949